/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import { OAUTH2 } from '../config-global';

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        authority: "https://login.microsoftonline.com/common/",
        clientId: OAUTH2.clientId,
        redirectUri: OAUTH2.redirectUri,
    },
    auth1: {
        authority: "https://login.microsoftonline.com/common/",

        clientId1: "bfe406fc-2ef3-490e-a409-0a44a302567d",
        clientId: '2531265b-726f-4da9-8827-b09274460ba8',
        redirectUri: "https://dqcdemo2.azureedge.net",
        redirectUri00: "http://localhost:3033/callback3",

        redirectUri22: "https://dqcdemo2.azureedge.net",
        redirectUri1: "http://localhost:3000/DQC_Demo",
        redirectUri2: "http://localhost:3000/callback3"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
//                        return;
                    default:
//                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    getIssue: "https://dqc-demo-functionapp.azurewebsites.net/api/GetIssue"
};
